import { render } from "./HomeTaskCount.vue?vue&type=template&id=35d70942&scoped=true"
import script from "./HomeTaskCount.vue?vue&type=script&lang=js"
export * from "./HomeTaskCount.vue?vue&type=script&lang=js"

import "./HomeTaskCount.vue?vue&type=style&index=0&id=35d70942&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d70942"]])

export default __exports__